/**
 * Rewrite Experience meter — mission retry charge on non-boss loss.
 * Authoritative target: `config/exploreUnknownBattleBonuses.json` → bonuses.rewriteExperience.collectParts
 */
export const EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_TARGET_PARTS = 5;

export const EXPLORE_UNKNOWN_REWRITE_EXPERIENCE_METER = Object.freeze({
  id: 'rewriteExperience',
  gameStatePartsKey: 'exploreUnknownRewriteExperiencePartsCollected',
  gameStateChargesKey: 'exploreUnknownRewriteExperienceCharges',
  apiKeyParts: 'rewriteExperiencePartsCollected',
  apiKeyCharges: 'rewriteExperienceCharges',
  image: '/images/retry.jpg',
  variant: 'rewrite',
  i18nKey: 'rewriteExperience',
  devSpawnActionType: 'devSpawnExploreUnknownRewriteExperience',
});
